import { currency } from "@Utils/index";
import { ICartLineItem, IDYCartEventItem } from "@wff/interfaces";
import {
  addToCart as dyAddToCart,
  purchase as dyPurchase,
  removeFromCart as dyRemoveFromCart,
  login as dyLogin,
  signup as dySignup,
  keywordSearch as dyKeywordSearch,
  newsletterSubscription as dyNewsletterSubscription,
  couponCode as dyCouponCode,
  sortItems as dySortItems,
  filterItems as dyFilterItems,
} from "./dynamicYield";

//Interfaces
interface ICartEventAddRemove extends IDYCartEventItem {}

interface IPurchaseEvent {
  uniqueTransactionId: string;
  totalCartValue: number;
  lineItems: ICartLineItem[];
}

export interface ICartEventUpdate {
  sku: string;
  quantity: number;
  prevQuantity: number;
  totalPrice: any;
  lineItems: ICartLineItem[];
}

// Utility Functions
export const structuredTotalPrice = (
  quantity: number,
  totalPrice: any
): number => {
  const totalPriceDollar = currency.convertToDollar(totalPrice);
  return Number((totalPriceDollar / quantity).toFixed(2));
};

// DY Events

/**
 * Add to Cart event
 * @param eventPayload
 */
export const addToCartEvent = (eventPayload: ICartEventAddRemove) => {
  const { sku, quantity, totalPrice, lineItems } = eventPayload;
  dyAddToCart({
    sku,
    quantity,
    totalPrice,
    lineItems,
  });
};

/**
 * Remove from Cart
 * @param eventPayload
 */
export const removeFromCartEvent = (eventPayload: ICartEventAddRemove) => {
  const { sku, quantity, totalPrice, lineItems } = eventPayload;
  dyRemoveFromCart({
    sku,
    quantity,
    totalPrice,
    lineItems,
  });
};

/**
 * Update Cart
 * @param eventPayload
 * @returns
 */
export const updateCartEvent = (eventPayload: ICartEventUpdate) => {
  const { sku, quantity, prevQuantity, totalPrice, lineItems } = eventPayload;
  const quantityToUpdate = quantity - prevQuantity;
  const itemPrice = structuredTotalPrice(quantity, totalPrice);
  const changedTotalPrice = Number((itemPrice * quantityToUpdate).toFixed(2));

  if (quantityToUpdate === 0) return;

  quantityToUpdate > 0
    ? addToCartEvent({
        sku,
        quantity: quantityToUpdate,
        totalPrice:
          quantity === 1 && prevQuantity === 0 ? totalPrice : changedTotalPrice,
        lineItems,
      })
    : removeFromCartEvent({
        sku,
        quantity: quantityToUpdate,
        totalPrice:
          quantity === 1 && prevQuantity === 0 ? totalPrice : changedTotalPrice,
        lineItems,
      });
};

export const purchaseEvent = (eventPayload: IPurchaseEvent) => {
  dyPurchase(eventPayload);
};

export const loginEvent = (email: string) => {
  dyLogin(email);
};

export const signupEvent = (email: string) => {
  dySignup(email);
};

export const keywordSearchEvent = (search: string) => {
  dyKeywordSearch(search);
};

export const newsletterSubscriptionEvent = (email: string) => {
  dyNewsletterSubscription(email);
};

export const couponCodeEvent = (code: string) => {
  dyCouponCode(code);
};

export const sortItemsEvent = (sortBy: string, sortOrder: string) => {
  dySortItems(sortBy, sortOrder);
};

export const filterItemsEvent = (filterName: string, filterValue: string) => {
  dyFilterItems(filterName, filterValue);
};
